document.querySelectorAll('.quantity-stepper').forEach((el) => {
    if (el.dataset.stepperInit) return;
    el.dataset.stepperInit = 'true';

    const input = el.querySelector('input[type=number]');

    el.querySelector('.qty-minus').addEventListener('click', () => {
        const v = parseInt(input.value) || 1;
        const min = parseInt(input.min) || 1;
        if (v > min) {
            input.value = v - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });

    el.querySelector('.qty-plus').addEventListener('click', () => {
        const v = parseInt(input.value) || 1;
        const max = parseInt(input.max);
        if (!max || v < max) {
            input.value = v + 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });
});